export type UpdateComponentRequest = {
  cpntId: string;
  godFlg: string;
  dipByRgn: string;
  cpntNameWtngChng: string;
  cpntDesc: string;
  rootCpntId: string;
  gpgEncryptnFlg: string;
  useAssmdRoleFlg: string;
  ediUsgFlg: string;
  useEdhCnvtrFlg: string;
  hubFlg: string;
  updateDateTime: string;
  edhPrtclList: EdhPrtcl[];
  ifStrtMthdList: IfStrtMthd[];
  edhNtfctnTypeList: EdhNtfctnType[];
};

type EdhPrtcl = {
  inOutTypeCd?: string;
  edhPrtclTypeCd?: string;
};
type IfStrtMthd = {
  ifStrtMthdTypeCd?: string;
};
type EdhNtfctnType = {
  inOutTypeCd?: string;
  edhNtfctnTypeCd?: string;
};
